export default __webpack_public_path__ + "static/media/yellowCar.5452675f.png";